import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "popupContainer" }
const _hoisted_2 = {
  key: 0,
  class: "content"
}
const _hoisted_3 = { class: "no_more" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["onClick"]

import { ContactServiceData, goToUrl } from '@/view/profile/supportScript';
import { ref, computed, onMounted } from 'vue'
import NoData from '../components/common/noData.vue';
import noRecordImg from '@/assets/themeFour/noData4.png';



export default /*@__PURE__*/_defineComponent({
  __name: 'contactService',
  props: {
    dataSet: {}
  },
  emits: ['open', 'close', 'update:show'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const emits = __emit

const open = () => {
    emits('open')
}
const close = () => {
    emits('close')
}
onMounted(() => {
     emits('open')
})

__expose({
    open,
    close
})


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.dataSet?.serviceList.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(NoData, {
              text:  _ctx.$t('common.noThreeData'),
              image: _unref(noRecordImg)
            }, null, 8, ["text", "image"])
          ])
        ]))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.dataSet?.serviceList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "serviceCard",
            key: index
          }, [
            _createVNode(_component_van_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, {
                  span: "4",
                  class: "avatarImage"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: item.avatar,
                      alt: ""
                    }, null, 8, _hoisted_4)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_van_col, {
                  span: "12",
                  class: "serviceTitle"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.nickname), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_van_col, {
                  span: "8",
                  style: {"display":"flex","align-items":"center","justify-content":"right"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "chat_btn",
                      onClick: ($event: any) => (_unref(goToUrl)(item.redirectUrl))
                    }, _toDisplayString(_ctx.$t('contactService.contacto')), 9, _hoisted_5)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]))
        }), 128))
  ]))
}
}

})